import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=ed98fb52&scoped=true&"
var script = {}
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=ed98fb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed98fb52",
  null
  
)

export default component.exports